import { defineStore } from 'pinia';
import { useRoute, useContext } from '@nuxtjs/composition-api';

interface PageState {
  routeData: any;
}

export const routeQuery = `
  query route($url: String!) {
    route(url: $url) {
      type
       ... on ProductInterface {
        sku
      }
      ... on CategoryTree {
        id
        uid
        children {
            uid
            name
        }
        name
      }
      ... on CmsPage {
        identifier
      }
    }
  }
`;

export const usePageResolver = () => {
  const route = useRoute();
  const { app } = useContext();

  const resolveUrl = async () => {
    const clearUrl = route.value.path
      .replace(/[a-z]+\/[cp|]\//gi, '')
      .replace(`/24orepro`, '');
  
    const { data, errors } = await app.$vsf.$magento.api.customQuery({
      query: routeQuery,
      customHeaders: {
        'Cache-Control': 'no-store, no-cache, must-revalidate',
        'Pragma': 'no-cache'
      },
      queryVariables: {
        url: clearUrl
      }
    });
  
    const results = (data as any)?.route ?? null;

    if (!results || errors?.length) {
      throw new Error('404');
    }

    if (results?.type === 'CATEGORY') {
      if (clearUrl.includes('temi-caldi.html')) {
        results.type = 'HOT_TOPICS';
      } else if (clearUrl.includes('/temi-caldi/')) {
        results.type = 'HOT_TOPIC';
      }
    }

    return results;
  };

  return {
    resolveUrl
  };
};

export const usePageStore = defineStore('page', {
  state: (): PageState => ({
    routeData: null,
  }),
});
